import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type dhrnCredType = CarrierLogisticsCredType
export const dhrnDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const dhrn: CarrierDef<dhrnCredType> = {
  name: 'Dohrn Transfer Company',
  scac: 'dhrn',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  ...carrierLogistics,
  engineLayers: ['documents', 'rating', 'pickup', 'profinder', 'tracking'],
  documentTypes: dhrnDocumentTypes,
}
